import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { getContentBlock } from '../../slices/content-block-slice';
import { colors } from '../../styles/GlobalStyles';
import { AnimatedDashboard } from '../../components';

export const TermsOfUse = () => {
  const dispatch = useAppDispatch();

  const { contentBlock, loading } = useAppSelector(
    (state) => state.contentBlock
  );

  useEffect(() => {
    dispatch(getContentBlock({ contentBlockId: 115, languageId: 1 }));
  }, [dispatch]);

  return (
    <AnimatedDashboard dark>
      {loading ? (
        <Spinner fullScreen={true} />
      ) : (
        <div
          style={{
            maxWidth: '800px',
            margin: '0 auto',
            marginTop: 50,
            color: colors.neutral0
          }}>
          <div
            dangerouslySetInnerHTML={{
              __html: contentBlock && contentBlock.content
            }}
          />
        </div>
      )}
    </AnimatedDashboard>
  );
};
